module.exports = __webpack_public_path__ + "img/professional-dashboard.6783cfd4.png";